import { Controller } from "@hotwired/stimulus"

// LOC-027, extended by LOC-039: live preview of the hero focal point. Reads both
// radio rows (vertical and horizontal) and swaps the modifier class on the
// preview image; the radios post without this controller.
export default class extends Controller {
  static targets = ["preview"]

  apply() {
    if (!this.hasPreviewTarget) return

    const vertical = this.checkedValue("user[locals_hero_focus]", "center")
    const horizontal = this.checkedValue("user[locals_hero_focus_x]", "center")

    this.previewTarget.classList.forEach((name) => {
      if (name.startsWith("locals-hero-focus--")) this.previewTarget.classList.remove(name)
    })
    this.previewTarget.classList.add(`locals-hero-focus--${vertical}-${horizontal}`)
  }

  checkedValue(name, fallback) {
    const checked = this.element.querySelector(`input[name="${name}"]:checked`)
    return checked ? checked.value : fallback
  }
}
